// MetricsCards.js
import React from 'react';
import { Card, Statistic, Row, Col } from 'antd';
import { 
  ShoppingOutlined, DollarOutlined,
  CheckCircleOutlined, CloseCircleOutlined,
  PercentageOutlined
} from '@ant-design/icons';
import { formatCurrency } from '../../../utils/dataUtils'; // Adjust the import path as necessary
import { CirclePlus } from 'lucide-react';

/**
 * Component to display key metrics as cards
 * @param {Object} props - Component props
 * @param {Object} props.metrics - Metrics data
 * @param {boolean} props.showPricesWithoutVAT - Whether to show prices without VAT
 */
const MetricsCards = ({ metrics, showPricesWithoutVAT }) => {
  // Base metrics cards (always shown)
  const baseMetricsCards = [
    <Col xs={24} md={12} lg={6} key="total-orders">
      <Card className="shadow-sm">
        <Statistic
          title="Total Orders"
          value={metrics.totalOrders}
          valueStyle={{ color: '#1890ff' }}
        
        />
      </Card>
    </Col>,
    <Col xs={24} md={12} lg={6} key="total-revenue">
      <Card className="shadow-sm">
        <Statistic
          title={showPricesWithoutVAT ? "Total (excl. VAT)" : "Total (incl. VAT)"}
          value={formatCurrency(metrics.totalRevenue)}
          valueStyle={{ color: '#3f8600' }}
         
        />
      </Card>
    </Col>,
    <Col xs={24} md={12} lg={6} key="successful-orders">
      <Card className="shadow-sm">
        <Statistic
          title="Successful Orders"
          value={metrics.successfulOrders}
          valueStyle={{ color: '#52c41a' }}
         
          suffix={metrics.totalOrders ? ` (${((metrics.successfulOrders / metrics.totalOrders) * 100).toFixed(1)}%)` : ''}
        />
      </Card>
    </Col>,
    <Col xs={24} md={12} lg={6} key="failed-orders">
      <Card className="shadow-sm">
        <Statistic
          title="Failed Orders"
          value={metrics.failedOrders}
          valueStyle={{ color: '#cf1322' }}
       
          suffix={metrics.totalOrders ? ` (${((metrics.failedOrders / metrics.totalOrders) * 100).toFixed(1)}%)` : ''}
        />
      </Card>
    </Col>
  ];

  // VAT metrics card (shown only when VAT toggle is active)
  const vatMetricsCard = showPricesWithoutVAT ? (
    <Col xs={24} md={12} lg={6} key="vat-amount">
      <Card className="shadow-sm">
        <Statistic
          title="VAT Amount"
          value={formatCurrency(metrics.totalVAT || 0)}
          valueStyle={{ color: '#722ed1' }}
         
        />
      </Card>
    </Col>
  ) : null;

  // Total including VAT card (shown only when VAT toggle is active)
  const totalWithVATCard = showPricesWithoutVAT ? (
    <Col xs={24} md={12} lg={6} key="total-with-vat">
      <Card className="shadow-sm">
        <Statistic
          title="Total (incl. VAT)"
          value={formatCurrency((metrics.totalRevenue || 0) + (metrics.totalVAT || 0))}
          valueStyle={{ color: '#eb2f96' }}
         
        />
      </Card>
    </Col>
  ) : null;

  return (
    <Row gutter={[16, 16]} className="mb-6">
      {baseMetricsCards}
      {vatMetricsCard}
      {totalWithVATCard}
    </Row>
  );
};

export default MetricsCards;